"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageLogs = void 0;
var _Modal = _interopRequireDefault(require("react-bootstrap/Modal"));
var _ModalBody = _interopRequireDefault(require("react-bootstrap/ModalBody"));
var _ModalFooter = _interopRequireDefault(require("react-bootstrap/ModalFooter"));
var _ModalHeader = _interopRequireDefault(require("react-bootstrap/ModalHeader"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsButton = require("../../components/DmsButton/DmsButton");
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _material = require("@mui/material");
var _DmsLogsTable = require("../../components/DmsLogs/DmsLogsTable");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageLogs Component
 * 
 * @description This component renders the Logs page. It displays a table of logs with various filters and a modal for viewing detailed information about individual logs.
 * 
 * @component
 * @example
 * return (
 *   <DmsPageLogs />
 * )
 * 
 * @returns {JSX.Element} The Logs page.
 */
const DmsPageLogs = () => {
  const [modalState, setModalState] = (0, _react.useState)(false);
  const [modalData, setModalData] = (0, _react.useState)({});
  const handleDetailsButton = (e, data, originalData) => {
    if (data.data) setModalData(data.data);else setModalData(null);
    setModalState(true);
  };
  const handleCloseModal = () => {
    setModalState(false);
  };
  const getData = data => {
    if (!data) return _reactIntlUniversal.default.get('Nodata').d('No data');
    try {
      return JSON.stringify(JSON.parse(data), null, 2);
    } catch (e) {
      return data;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Logs"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("Logs").d("Logs"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsLogsTable.DmsLogsTable, {
    onDetailsClick: handleDetailsButton
  }), /*#__PURE__*/_react.default.createElement(_Modal.default, {
    show: modalState,
    onHide: handleCloseModal
  }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
    closeButton: true
  }, /*#__PURE__*/_react.default.createElement("h5", {
    className: "modal-title"
  }, _reactIntlUniversal.default.get("Details").d("Details"))), /*#__PURE__*/_react.default.createElement(_ModalBody.default, null, /*#__PURE__*/_react.default.createElement("pre", null, getData(modalData))), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, null, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "secondary",
    text: _reactIntlUniversal.default.get("Close").d("Close"),
    onClick: handleCloseModal
  }))))));
};
exports.DmsPageLogs = DmsPageLogs;